import { useIframeMessaging } from "../iframeMessaging/useIframeMessaging";

export const useIframeVisibility = (iframeName: string) => {
  const { publishMessage } = useIframeMessaging();

  return (isVisible: boolean) => {
    publishMessage('iframeVisibility', { isVisible, iframeName })
  }

}